import classnames from 'classnames'
import {css} from 'emotion'
import React from 'react'
import type {
  TSubmitMajorActionResponse,
  TSubmitMinorActionResponse,
} from '@kapitalist/contract/endpoints'
import type {TRuleset} from '@kapitalist/contract/ruleset'
import {isInstance} from '@kapitalist/utils/types'
import type {TSkin} from '~/game/skins'
import type GameData from '~/models/game/GameData'
import ExposedHand from '~/models/game/Hands/ExposedHand'
import type MajorAction from '~/models/game/MajorAction'
import type {AnyCard, AnyMinorAction} from '~/models/game/types'
import {CARD_WIDTH_PX} from '~/pages/GameLobbyV2/cardGeometry'
import {cardVisualStates} from '~/pages/GameLobbyV2/cardVisualState'
import type {TClickableCardStateV2} from '~/pages/GameLobbyV2/clickableCardState'
import {V2LobbyCardImage} from '~/pages/GameLobbyV2/utils'
import styles from './styles.module.css'

interface IProps {
  gameData: GameData
  chooseMajorAction: (majorAction: MajorAction) => Promise<unknown>
  chooseMajorActionSubmitSuccess: (response: TSubmitMajorActionResponse) => void
  chooseMinorAction: (
    minorAction: AnyMinorAction
  ) => Promise<TSubmitMinorActionResponse>
  chooseMinorActionSubmitSuccess: (response: TSubmitMinorActionResponse) => void

  skin: TSkin
  rules: TRuleset

  className?: string

  clickableCardState: TClickableCardStateV2
  onCardClicked: (card: AnyCard, event: React.MouseEvent<any>) => void
}

interface IState {}

export default class HandDrawerUI extends React.Component<IProps, IState> {
  state: IState = {}

  render() {
    const {skin, gameData, clickableCardState, onCardClicked} = this.props
    const {currentGamePosition, playerGamePosition} = gameData

    const currentPlayerHand = playerGamePosition?.currentPlayer.hand
    // TODO Could rotate this for spectators. Also this isn't tied to whoever's turn it is, or who's in seat 0, so...
    const exposedHand: ExposedHand | undefined =
      currentPlayerHand ??
      currentGamePosition.players.map(p => p.hand).find(isInstance(ExposedHand))

    if (!exposedHand) {
      // TODO some UI for spectators to ask to spectate?
      return null
    }

    const visualStateFor = cardVisualStates(clickableCardState, currentGamePosition)

    return (
      <div className={classnames(styles.handDrawerWrapper, this.props.className)}>
        <div className={styles.cards}>
          {exposedHand?.cards.map(c => {
            const visualState = visualStateFor(c.id)
            return (
              <V2LobbyCardImage
                key={c.id}
                className={classnames(
                  styles.card,
                  visualState.clickable && styles.clickable,
                  visualState.selected && styles.selected,
                  visualState.fadeUnclickable && styles.fadeUnclickable,
                  visualState.highlighted && styles.highlighted,
                  visualState.faded && styles.faded,
                  css`
                    width: ${CARD_WIDTH_PX.hand}px;
                  `
                )}
                model={c}
                invert={false}
                skin={skin}
                forceRoundedCornersOnSharpCornerSkins
                onClick={e => {
                  visualState.clickable && onCardClicked(c, e)
                }}
              />
            )
          })}
        </div>
      </div>
    )
  }
}
